<div class="toast">
  <button type="button"
          class="button icon-button close-button"
          [attr.aria-label]="'notification.toast.dismiss' | translate"
          (click)="dismiss()">
    <app-icon name="ic_close"/>
  </button>

  <div class="toast-content">
    <div class="icon-circle">
      @if (notificationContent.icon) {
        <app-icon [name]="notificationContent.icon | icons"/>
      }
    </div>

    <div class="copy">
      <div class="meta">
        <app-tag size="small" [level]="data.notification.level">
          {{ LabelConverter.getNotificationLevelLabel(data.notification.level) | translate }}
        </app-tag>
        <small>{{ data.notification.eventDate | relativeDate }}</small>
      </div>

      <h4>{{ notificationContent.headline }}</h4>

      @if (notificationContent.text) {
        <p>{{ notificationContent.text }}</p>
      }
    </div>
  </div>

  <div class="actions">
    @if (hasLink) {
      <button type="button" class="button icon-button" (click)="openNotification()">
        {{ 'notification.toast.open' | translate }}
        <app-icon name="ic_chevron_right"/>
      </button>
    }
  </div>
</div>
